import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Paper, Stack, Typography } from 'styles';
import PaymentStack from 'styles/stack/PaymentStack';
import { useTheme } from 'stylesHooks';
import { PaymentDetailsType } from 'types/Payment';
import { useTranslation } from 'utils/translations';
import { formatPrice } from 'utils/utils';

const Ticket = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});
	const { paymentDetails } = useSelector((store: RootState) => store.payment);
	const theme = useTheme();

	const Total = (
		<>
			<Typography variant="bodyLink">
				{tClientLabels('payment.details.ticketTotal')}:
			</Typography>
			<Typography variant="price1">
				{formatPrice(paymentDetails.paymentAmount.total)}
			</Typography>
		</>
	);

	const typographySX = { width: '100%' };
	const stackSX = {
		alignItems: 'center',
		gap: 2,
		width: '100%',
		justifyContent: 'space-between',
		px: 2.5,
	};

	return (
		<>
			<Stack>
				<Stack gap={1.5} mb={2.5}>
					<Stack
						bgcolor={theme.palette.white.main}
						py={0.875}
						sx={stackSX}
						direction={'row'}
					>
						<Typography variant="bodyLink" sx={typographySX}>
							{tClientLabels('payment.details.quantity')}
						</Typography>
						<Typography variant="bodyLink" sx={typographySX}>
							{tClientLabels('payment.details.VATdescription')}
						</Typography>
						<Typography variant="bodyLink" sx={typographySX}>
							{tClientLabels('payment.details.amount')}
						</Typography>
						<Typography variant="bodyLink" sx={typographySX}>
							{tClientLabels('payment.details.discount')}
						</Typography>
						<Typography variant="bodyLink" sx={typographySX}>
							{tClientLabels('payment.details.retailNetOfTax')}
						</Typography>
						<Typography variant="bodyLink" sx={typographySX}>
							{tClientLabels('payment.details.vatLabel')}
						</Typography>
					</Stack>
					<Stack direction={'row'} sx={stackSX}>
						<Typography variant="body" sx={typographySX}>
							{paymentDetails.paymentInfo.quantity}
						</Typography>
						<Typography variant="body" sx={typographySX}>
							{tDbLabels(paymentDetails.paymentInfo.vatDescription)}
						</Typography>
						<Typography variant="body" sx={typographySX}>
							{formatPrice(paymentDetails.paymentAmount.amount)}
						</Typography>
						<Typography variant="body" sx={typographySX}>
							-
						</Typography>
						<Typography variant="body" sx={typographySX}>
							{formatPrice(paymentDetails.paymentAmount.subTotal)}
						</Typography>
						<Typography variant="body" sx={typographySX}>
							{formatPrice(paymentDetails.paymentAmount.vat)}
						</Typography>
					</Stack>
				</Stack>
				{paymentDetails.detailType !== PaymentDetailsType.EOP && (
					<Paper elevation={0} variant="payment" className="roundAll">
						<Stack
							display={'flex'}
							flexGrow={1}
							gap={'15px'}
							pt={3.75}
							pb={2.5}
							px={1.25}
						>
							<Stack flexGrow={1} direction={'row'} justifyContent={'space-between'}>
								<Typography variant="body">
									{tClientLabels('payment.details.netTotal')}
								</Typography>
								<Typography variant="bodyLink">
									{formatPrice(paymentDetails.paymentAmount.subTotal)}
								</Typography>
							</Stack>
							<Stack flexGrow={1} direction={'row'} justifyContent={'space-between'}>
								<Typography variant="body">
									{tClientLabels('payment.details.vat')}
								</Typography>
								<Typography variant="bodyLink">
									{formatPrice(paymentDetails.paymentAmount.vat)}
								</Typography>
							</Stack>
							<PaymentStack
								flexGrow={1}
								direction={'row'}
								justifyContent={'space-between'}
								pb={1.875}
								sx={{ borderBottom: '1px dashed #bbbbbb' }}
							>
								<Typography variant="body">
									{tClientLabels('payment.details.documentTotal')}
								</Typography>
								<Typography variant="bodyLink">
									{formatPrice(paymentDetails.paymentAmount.total)}
								</Typography>
							</PaymentStack>
						</Stack>
					</Paper>
				)}
				<Paper elevation={0} variant="payment" className="roundTop">
					<Stack
						display={'flex'}
						flexDirection={'row'}
						flexGrow={1}
						justifyContent={'space-between'}
						alignItems={'center'}
						alignSelf={'stretch'}
						pb={3.75}
						px={1.25}
					>
						<>{Total}</>
					</Stack>
				</Paper>
			</Stack>
		</>
	);
};

export default Ticket;
